var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        id: "integrate-cb-with-gpt3-modal",
        title: _vm.$t("chatbotv2.integrateChatBotWithChatGPT3"),
        wrapClassName: "vertical-center-modal",
        visible: _vm.modalVisible,
        footer: null,
      },
      on: {
        visibleChange: function (isVisible) {
          return _vm.$emit("modal-visible2", isVisible)
        },
        cancel: function ($event) {
          return _vm.handleCancel()
        },
      },
    },
    [
      _c(
        "a-form",
        {
          staticClass: "d-flex flex-column justify-content-center",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSave.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "a-form-item",
            {
              attrs: { label: _vm.$t("chatbotv2.integrateOpenAIWithChatbot") },
            },
            [
              _c(
                "a-radio-group",
                {
                  staticClass: "row",
                  on: { change: _vm.onChange },
                  model: {
                    value: _vm.gpt3UsageStatus,
                    callback: function ($$v) {
                      _vm.gpt3UsageStatus = $$v
                    },
                    expression: "gpt3UsageStatus",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "col mb-5" },
                    [
                      _c(
                        "a-radio",
                        {
                          staticClass: "mb-1 text-bold",
                          attrs: { value: "pro" },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("chatbotv2.gpt3.ownApiKey")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.gpt3UsageStatus === "pro"
                        ? _c(
                            "a",
                            { attrs: { href: _vm.link, target: "_blank" } },
                            [
                              _c(
                                "a-alert",
                                {
                                  attrs: {
                                    message: _vm.$t("chatbotv2.gpt3.getApiKey"),
                                    type: "info",
                                    "show-icon": "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "description" },
                                      slot: "description",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "overflow-preventer" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbotv2.openAISiteRoutingDescStart"
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "aalert-message" },
                                            [
                                              _vm._v(
                                                '"' + _vm._s(_vm.link) + '"'
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbotv2.openAISiteRoutingDescEnd"
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.gpt3UsageStatus === "pro"
                        ? _c("a-input", {
                            staticClass: "mt-2",
                            attrs: {
                              autofocus: "",
                              value: _vm.apiKey,
                              placeholder: _vm.$t("chatbotv2.gpt3.typeApiKey"),
                            },
                            on: { change: _vm.onChange, input: _vm.getInput },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col mb-2" },
                    [
                      _c(
                        "a-radio",
                        {
                          staticClass: "mb-1 text-bold",
                          attrs: { value: "free" },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("chatbotv2.gpt3.trialApiKey")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.gpt3UsageStatus === "free"
                        ? _c(
                            "a-alert",
                            {
                              attrs: {
                                message: _vm.$t("chatbotv2.gpt3.useOurTrial"),
                                type: "info",
                                "show-icon": "",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  attrs: { slot: "description" },
                                  slot: "description",
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("chatbotv2.gpt3.twentyMessages")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "chatbotv2.remainingMessageDesc"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "aalert-message" },
                                      [_vm._v(_vm._s(_vm.trialMessageLimit))]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row justify-content-between" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-row justify-content-start" },
          [
            (!!_vm.apiKey && _vm.apiKey.length > 0) || _vm.trial
              ? _c(
                  "a-button",
                  {
                    attrs: { type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.revokeDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("a-icon", {
                          staticClass: "px-1",
                          attrs: { type: "api" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      _vm._s(_vm.$t("chatbotv2.uninstall")) + "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-row justify-content-end" },
          [
            _c(
              "a-button",
              {
                staticClass: "mr-1 ant-btn-primary",
                on: {
                  click: function ($event) {
                    return _vm.handleOk()
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chatbotv2.install")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "ml-1",
                on: {
                  click: function ($event) {
                    return _vm.handleCancel()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.cancel")))]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }